import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  IconButton,
  Stack,
  Box,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  confirmMessage?: string;
  onConfirm: () => void;
  item: string;
  itemName: string;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  item,
  confirmMessage,
  loading = false,
  itemName,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: 480,
          borderRadius: 3,
          backgroundColor: "#fff",
          px: 2,
        },
      }}
    >
      <DialogTitle
        id="delete-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
          pt: 4,
          pb: 2,
        }}
      >
        <WarningAmberRoundedIcon
          color="warning"
          sx={{ fontSize: 48, mb: 1 }}
        />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {confirmMessage ?? "Do You Want to Delete"}{" "}
          <Box component="span" fontWeight={700} color="error.main">
            {itemName}
          </Box>
          ?
        </Typography>
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 12,
          right: 12,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <img alt="Close icon" src="/x.png" height="18" />
      </IconButton>

      <DialogContent sx={{ textAlign: "center", py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {item}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ flexDirection: "column", gap: 1.5, pb: 3, px: 4 }}>
        <LoadingButton
          onClick={onConfirm}
          loading={loading}
          variant="contained"
          color="error"
          fullWidth
          sx={{
            textTransform: "none",
            borderRadius: 20,
            fontWeight: 600,
            py: 1.2,
            fontSize: "1rem",
          }}
        >
          Confirm Delete
        </LoadingButton>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          fullWidth
          sx={{
            textTransform: "none",
            borderRadius: 20,
            py: 1.2,
            fontWeight: 500,
            fontSize: "1rem",
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
